import BreadCrumb from 'components/__ASSESSOR__/BreadCrumb/BreadCrumb';
import PublicContainer from 'components/__SHARED__/PublicContainer';
import { getApis } from 'library/Apis';
import { basePath, PrivacyPolicyRoutePath } from 'library/Routes';
import { Col, Row } from 'plataforma-fundacao-componentes';
import { useEffect } from 'react';
import { Fragment } from 'react';
import { Helmet } from 'react-helmet';

export default function CookiePolicy() {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://web-static.sicredi.io/lgpd-politica-cookies-lib@1/static/css/main.css';

    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return getApis()?.cookies?.active ? (
    <Fragment>
      <Helmet>
        <script src='https://web-static.sicredi.io/lgpd-politica-cookies-lib@1/static/js/main.js'></script>
      </Helmet>
      <PublicContainer key='cookies-on'>
        <Row centralized>
          <Col style={{ maxWidth: '1066px', marginTop: '12px', zIndex: '100' }}>
            <BreadCrumb
              itens={[
                { nome: 'Ínicio', url: basePath },
                {
                  nome: 'Política de privacidade',
                  url: PrivacyPolicyRoutePath,
                },
                {
                  nome: 'Política de cookies',
                },
              ]}
            />
          </Col>
          <div
            id='politica-cookies-root'
            politica-pravacidade-url={`${window.location.origin}/assembleias/politica-privacidade`}
            uuid-dominio={getApis().cookies.uuid}
            data-enviroment={getApis().cookies.env}
            style={{ backgroundColor: 'transparent', marginTop: '-100px' }}
          />
        </Row>
      </PublicContainer>
    </Fragment>
  ) : (
    <Fragment key='cookies-off' />
  );
}
